import { useSyncExternalStore } from "react"

function fakeSubscribe() {
  return () => {}
}

// A value only the browser knows, read once at hydration. The server and the
// initial hydration pass on the client use `serverValue`. Restricted to
// booleans so the snapshot is stable under Object.is.
export function useClientFlag(
  getClientValue: () => boolean,
  serverValue = false,
) {
  return useSyncExternalStore(fakeSubscribe, getClientValue, () => serverValue)
}
